import { AdvertBannerSlider } from '../../dashboard/DashboardBannerSlider';
import { useEffect, useRef } from 'react';
import { useAdverts } from '../../hooks/useAdverts';
import { storeAdvertInteraction } from '../../services/advertService';
import { safeMediaUrl } from './searchMedia';
import { searchIsLoading } from './SearchShimmer';

export default function SearchAdvert({ position, categoryId, stateId }) {
  const query = useAdverts({ position_key: position, ad_format: 'regular', category_id: categoryId, states_id: stateId });
  const data = query.data?.dataset?.data;
  const items = (Array.isArray(data) ? data : data?.adverts || []).filter((item) => safeMediaUrl(item.image_url || item.advert_image || item.image));
  const tracked = useRef(new Set());
  useEffect(() => {
    items.forEach((item) => {
      if (!item.id || tracked.current.has(item.id)) return;
      tracked.current.add(item.id);
      storeAdvertInteraction({ position, adverts_id: item.id, interaction_type: 0, web_url: window.location.href, states_id: stateId, category_id: categoryId }).catch(() => {});
    });
  }, [items, position, stateId, categoryId]);
  if (searchIsLoading(query)) return <div className="BannerDashboard search-shimmer" role="status" aria-label="Loading advertisement" aria-busy="true"><div aria-hidden="true" className="dashboard-skeleton search-shimmer__banner" /></div>;
  const banners = items.map((item) => ({
    id: item.id,
    name: item.name || item.title || 'Advertisement',
    image: safeMediaUrl(item.image_url || item.advert_image || item.image),
    url: safeMediaUrl(item.advert_url || item.url),
  }));
  const onBannerClick = (banner) => {
    if (!banner.url) return;
    storeAdvertInteraction({ position, adverts_id: banner.id, interaction_type: 1, web_url: window.location.href, states_id: stateId, category_id: categoryId }).catch(() => {});
    window.open(banner.url, '_blank', 'noopener,noreferrer');
  };
  return <AdvertBannerSlider banners={banners} onBannerClick={onBannerClick} />;
}
